export default "__VITE_ASSET__4a27b3d4__"